import { NgModule } from "@angular/core";
import { AutoFocusDirective } from "./auto-focus.directive";
import { IosToggleDirective } from "./ios-toggle.directive";
import { NgLetDirective } from "./ng-let.directive";

@NgModule({
	declarations: [NgLetDirective, AutoFocusDirective, IosToggleDirective],
	exports: [NgLetDirective, AutoFocusDirective, IosToggleDirective],
})
export class DirectivesModule {}
